import IAnswerTemplate from "../typings/IAnswerTemplate";
import http from "./client";

// В целом по API вопросы, названия эндпоинтов можно и нужно редактировать так, как
// это принято будет на АТ в будущем, если мы хотим переезжать на взаимодействие через API.
// А так стандартный CRUD, по местному fetch пока не знаю, есть ли смысл в пагинации?
// Посмотреть бы, сколько в среднем у автора бывает шаблонов

// Делаем запрос на получение существующих шаблонов. Если указываем только course_id,
// то получем общекурсовые шаблоны. Если указан course_id и lesson_id - то специфичные для урока
// шаблоны

interface IAnswerTemplatesFetchQueryParams {
  course_id: number | string;
  lesson_id?: number | string;
  page?: number | string;
  limit?: number | string;
}

interface IAnswerTemplatesFetchResponse {
  success: boolean;
  errorMessage?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<IAnswerTemplate>;
}

async function fetch(queryParams: IAnswerTemplatesFetchQueryParams): Promise<IAnswerTemplatesFetchResponse> {
  const response = await http.get<IAnswerTemplatesFetchResponse>('/api/answertemplates/list', {
    params: queryParams,
  });
  return response.data;
}

// Создание шаблона, обращаемся с course_id и lesson_id по аналогии с предыдущим методом
// Поля ответа на операцию также открытый вопрос. Пока сделал предположение, что будет
// status: success/error, message - опциональный для error, id - опциональный для success

interface IAnswerTemplatesCreateData {
  course_id: number | string;
  lesson_id?: number | string;
  name: string;
  details: string;
}

interface IAnswerTemplatesCreateResponse {
  success: boolean;
  data?: IAnswerTemplatesCreateData
  errorMessage?: string;
}

async function create(data: IAnswerTemplatesCreateData): Promise<IAnswerTemplatesCreateResponse> {
  const response = await http.post<IAnswerTemplatesCreateResponse>('/api/answertemplates/save', data);
  return response.data;
}

// Редактирование шаблона, обращаемся по id. Передаем также name и details.
// Поля ответа на операцию также открытый вопрос. Пока сделал предположение, что будет status: success/error,
// message - опциональный для error

interface IAnswerTemplatesEditData {
  course_id: number | string;
  id: number | string;
  name: string;
  details: string;
}

interface IAnswerTemplatesEditResponse {
  success: boolean
  data?: IAnswerTemplatesEditData
  errorMessage?: string;
}

async function edit(data: IAnswerTemplatesEditData): Promise<IAnswerTemplatesEditResponse> {
  const response = await http.post<IAnswerTemplatesEditResponse>('/api/answertemplates/save', data);
  return response.data;
}

// Удаление шаблона, обращаемся по id. Поля ответа на операцию также открытый вопрос. Пока сделал предположение,
// что будет status: success/error, message - опциональный для error

interface IAnswerTemplatesRemoveData {
  course_id: number | string;
  id: number | string;
}

interface IAnswerTemplatesRemoveResponse {
  success: boolean
  errorMessage?: string;
}

async function remove(data: IAnswerTemplatesRemoveData): Promise<IAnswerTemplatesRemoveResponse> {
  const response = await http.post<IAnswerTemplatesRemoveResponse>('/api/answertemplates/delete', data);
  return  response.data;
}

const answerTemplates = {
  fetch, create, edit, remove,
}

export default answerTemplates;